
export const COLUMNS = [
    {
        Header: 'Datum merenja',
        accessor: 'measurementDate'
    },
    {
        Header: 'Visina',
        accessor: 'height'
    },
    {
        Header: 'Mere',
        accessor: 'size'
    },
    {
        Header: 'Telesna Masa',
        accessor: 'bodyMass'
    },
    {
        Header: '% masti',
        accessor: 'fatPercentage'
    },
    {
        Header: '% vode',
        accessor: 'waterPercentage'
    },
    {
        Header: '% visceralnih masti',
        accessor: 'visceralFat'
    },
    {
        Header: 'Mišićna masa',
        accessor: 'muscleMass'
    },
    {
        Header: 'Ocena fizičke spremnosti',
        accessor: 'bodyFitnessIndex'
    },
    {
        Header: 'Masa kostiju',
        accessor: 'boneMass'
    },
    {
        Header: 'Bazalni metabolizam',
        accessor: 'baseMetabolism'
    },
    {
        Header: 'Metabolicka starost',
        accessor: 'metabolicAge'
    },
    {
        Header: 'BMI',
        accessor: 'bmi'
    },
    {
        Header: 'Nadlaktica',
        accessor: 'upperArm'
    },
    {
        Header: 'Grudi',
        accessor: 'chest'
    },
    {
        Header: 'Struk',
        accessor: 'waist'
    },
    {
        Header: 'Kukovi',
        accessor: 'hips'
    },
    {
        Header: 'Butine',
        accessor: 'thighs'
    },
    {
        Header: 'Stomak',
        accessor: 'stomach'
    },
]